import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 40);
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <nav className="nav">
          <div className="nav-brand">
            {/* <Link to="/">
              <img className="header-logo" src="./logo64.jpg" alt="VN2Pixel" />
            </Link> */}
          </div>
          <ul className="nav-menu">
            <li>
              <NavLink
                to="/trang-chu"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Giới Thiệu
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/quy-dinh"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Quy định
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/2025"
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                Bản đồ 2025
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};
export default Header;
